import PageBase from '@glittr/frontend-core/src/core/v2/app/pageBase';
import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import GetOrganisationForUserRequestModel from '../../../../../services/v2/model/get-organisation-for-user-request-model';
import LookupRequestModel from '../../../../../services/v2/model/lookup-request-model';
import GuidEventLookupModel from '../../../../../services/v2/model/guid-event-lookup-model';

export default class EditOrganisationsPage extends PageBase {
  public get companiesList() {
    return this.companiesDataSource.data?.items.map((i) => { return { ...i.data }; }) || [];
  }

  public set companiesList(value) { /* Do nothing */ }

  public eventItems: GuidEventLookupModel[] | undefined;

  public companyColumns = [
    { value: Vue.$t('page.companies.table.id'), textAlign: 'left', field: 'id' },
    { value: Vue.$t('page.companies.table.companyName'), textAlign: 'left', field: 'companyName' },
    { value: Vue.$t('page.companies.table.companyContactFirstName'), textAlign: 'left', field: 'companyContactFirstName' },
    { value: Vue.$t('page.companies.table.companyContactLastName'), textAlign: 'left', field: 'companyContactLastName' },
    { value: Vue.$t('page.companies.table.companyContactPhoneNumber'), textAlign: 'left', field: 'companyContactPhoneNumber' },
    { value: Vue.$t('page.companies.table.companyContactEmail'), textAlign: 'left', field: 'companyContactEmail' },
    { value: '', field: 'actions' },
  ];

  public companiesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Companies.getCompanies,
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    this.companiesDataSource.filter.selectedOrganisationId = (await Vue.$service.v2.api.tdg_Organisations.getOrganisationForUser(new GetOrganisationForUserRequestModel())).data.id;
    this.companiesDataSource.filter.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
    await this.companiesDataSource.select();
  }

  async refreshCompanies() {
    try {
      this.companiesDataSource.filter.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      await this.companiesDataSource.select();
    } catch (error) {
      Vue.$log.error(`Error refreshing companies: ${error}`);
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
      }
    }
  }
}
